module.exports = __webpack_public_path__ + "img/listen.1a9b6ec9.png";